import { init } from './map_manager';
import './css/map.css';
import "leaflet/dist/leaflet.css";

document.addEventListener("DOMContentLoaded", function(event) { 
    init();
});